<!-- @format -->

<div class="modal-header">
  <h2 class="modal-title">{{ "ENROLMENT.ENROLMENT_MODAL.CANCEL_HEADER" | translate }}</h2>
  <sis-button (clicked)="dismiss()" [link]="true" class="modal-close">
    <sis-icon icon="ring-close"></sis-icon>
  </sis-button>
</div>
<div class="modal-body">
  @if (cancellationFailed$ | async) {
    <sis-contextual-notification variant="danger" data-cy="cancellation-failed-notification">
      {{ "ENROLMENT.ENROLMENT_MODAL.CANCEL_ENROLMENT_FAILED" | translate }}
    </sis-contextual-notification>
  }
  @if (
    {
      courseUnit: enrolment?.courseUnitId | courseUnit | async,
      assessmentItem: enrolment?.assessmentItemId | assessmentItem | async,
      courseUnitRealisation: enrolment?.courseUnitRealisationId | courseUnitRealisation | async,
    };
    as data
  ) {
    <sis-study-realisation-box
      [activityPeriod]="data.courseUnitRealisation?.activityPeriod"
      [code]="data.courseUnit?.code"
      [credits]="data.assessmentItem?.credits"
      [name]="data.courseUnit?.name"
      [realisationName]="data.courseUnitRealisation?.name"
      [level]="3"
      class="my-5 d-block">
    </sis-study-realisation-box>
  }
  @if (enrolment?.studyRightId | studyRightName | async; as studyRightName) {
    <sis-description-list>
      <dl>
        <ng-template #listItem>
          <dt>{{ "ENTITY_NAMES.StudyRight" | translate }}</dt>
          <dd>{{ studyRightName | localizedString }}</dd>
        </ng-template>
      </dl>
    </sis-description-list>
  }
</div>
<div class="modal-footer">
  <sis-button (clicked)="dismiss()" [hollow]="true">{{ "SIS_COMPONENTS.BUTTON.CANCEL" | translate }}</sis-button>
  <sis-button (clicked)="cancel$.next()" data-cy="confirm-button">{{ "SIS_COMPONENTS.BUTTON.CONFIRM" | translate }}</sis-button>
</div>
